import React, { useState, useEffect } from "react";
import Select from "@atlaskit/select";
import { useSelector } from "react-redux";
import { NONE } from "../common/constants/core/common.constants";
import { ATLASSIAN_AUTH_TOKEN } from "../common/constants/core/cred.constants";
import { CredentialsReferenceType } from "../common/interfaces/flow/action/WebRequestAction";

const NONE_OPTION = { label: NONE, value: "" };
const ATLASSIAN_AUTH_OPTION = {
  label: "Atlassian Authorization token",
  value: ATLASSIAN_AUTH_TOKEN,
  type: CredentialsReferenceType.ATLASSIAN_TOKEN,
};

const CredentialPicker = ({ onSelect, value, showOnlyCredType }) => {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(NONE_OPTION);
  const creds = useSelector((state) => state.auth.creds);

  useEffect(() => {
    //console.log("useEffect",value)
    const loadedOptions = creds ? toModel(creds) : [];
    loadedOptions.unshift(ATLASSIAN_AUTH_OPTION);
    loadedOptions.unshift(NONE_OPTION);
    setOptions(loadedOptions);

    const newSelectedOption = loadedOptions.find((op) => op.value === value) || NONE_OPTION;
    setSelectedOption(newSelectedOption);
  }, [creds, value]);

  const toModel = (appList) =>
    appList
      .filter((app) => !showOnlyCredType || app.type === showOnlyCredType)
      .map((app) => ({
        label: `${app.name} [${app.type}]`,
        value: app.id,
        type: CredentialsReferenceType.DATABASE_REF,
      }));

  const selectCredential = (config) => {
    setSelectedOption(config?.value === null ? "" : config);
    let cred = config ? {
      value: config.value,
      type: config.type,
    } : null;
    onSelect(cred);
  };

  return (
    <Select
      menuPortalTarget={document.body}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      className="ihub-CredentialPicker-app"
      classNamePrefix="react-select"
      options={options}
      placeholder={NONE}
      spacing="compact"
      isRequired={false}
      value={selectedOption}
      onChange={selectCredential}
      name="credentialPicker"
      isClearable={true}
    />
  );
};

export default CredentialPicker;
